import { MultiLanguage } from '@/Domain/Entities';

export default class CandidateProcess {
    private _inscriptionId: string;
    private _processId: string;
    private _title: MultiLanguage;
    private _type: number;
    private _phase: number;
    private _oppositionType: number;
    private _inscriptionStatus: number;
    private _blockAccessToAdmin: boolean;

    public constructor(data: any) {
        this._inscriptionId = data.inscriptionId;
        this._processId = data.processId;
        this._title = new MultiLanguage(data.title);
        this._type = data.type;
        this._phase = data.phase;
        this._oppositionType = data.oppositionType;
        this._inscriptionStatus = data.inscriptionStatus;
        this._blockAccessToAdmin = data.blockAccessToAdmin;
    }

    public get inscriptionId() {
        return this._inscriptionId;
    }

    public get processId() {
        return this._processId;
    }

    public get title(): MultiLanguage {
        return this._title;
    }

    public get type() {
        return this._type;
    }

    public get phase() {
        return this._phase;
    }

    public get oppositionType() {
        return this._oppositionType;
    }

    public get inscriptionStatus() {
        return this._inscriptionStatus;
    }

    public get blockAccessToAdmin() {
        return this._blockAccessToAdmin;
    }
}
